import React, { useState } from "react";

import { useAuth0 } from "@auth0/auth0-react";
import { Role } from "@nestoca/gate-core";
import { getAuthToken } from "@shared/api/client";
import { INACTIVITY_TIMEOUT_MIN } from "@shared/constants";
import { currentUser } from "@shared/store";
import { IdleTimeout, useAutoRefreshToken, useValidateRid } from "@shared/ui";
import { useSetAtom } from "jotai";

import { GateProvider } from "./gate-provider";

interface UserProviderProps {
  rid?: string;
  children: React.ReactNode;
}

export const UserProvider = ({ rid, children }: UserProviderProps) => {
  const { isLoading, isAuthenticated, user, logout } = useAuth0();
  const [permissions, setPermissions] = useState<string[]>([]);
  const [role, setRole] = useState<Role>();
  const authToken = getAuthToken();

  const setCurrentUser = useSetAtom(currentUser);

  useValidateRid(rid);

  useAutoRefreshToken({
    setCurrentUser,
    setPermissions,
    setRole,
  });

  // when want Auth0 `Auth0Provider` to redirect to the login page
  if (isLoading || !isAuthenticated) {
    return <>{children}</>;
  }

  // when authenticated wait for `getAccessTokenSilently` to be resolved
  if (isAuthenticated && (!authToken || !user)) {
    return null;
  }

  const idleTimeout = INACTIVITY_TIMEOUT_MIN(30);

  return (
    <>
      <GateProvider user={user} permissions={permissions} role={role}>
        <>{children}</>
      </GateProvider>
      <IdleTimeout timeout={idleTimeout} logout={logout} />
    </>
  );
};
